// Date formatting utilities for IST timezone

/**
 * Format ISO datetime to dd/mm/yyyy HH:MM:SS IST
 */
export function formatDateTimeIST(isoString) {
  if (!isoString) return 'N/A';
  try {
    const date = new Date(isoString);
    // Convert to IST (UTC+5:30)
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);
    
    const day = String(istDate.getUTCDate()).padStart(2, '0');
    const month = String(istDate.getUTCMonth() + 1).padStart(2, '0');
    const year = istDate.getUTCFullYear();
    const hours = String(istDate.getUTCHours()).padStart(2, '0');
    const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(istDate.getUTCSeconds()).padStart(2, '0');
    
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} IST`;
  } catch {
    return isoString;
  }
}

/**
 * Format ISO datetime to dd/mm/yyyy
 */
export function formatDateIST(isoString) {
  if (!isoString) return 'N/A';
  try {
    const date = new Date(isoString);
    // Convert to IST (UTC+5:30)
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);
    
    const day = String(istDate.getUTCDate()).padStart(2, '0');
    const month = String(istDate.getUTCMonth() + 1).padStart(2, '0');
    const year = istDate.getUTCFullYear();
    
    return `${day}-${month}-${year}`;
  } catch {
    return isoString;
  }
}

/**
 * Format ISO datetime to HH:MM IST
 */
export function formatTimeIST(isoString) {
  if (!isoString) return 'N/A';
  try {
    const date = new Date(isoString);
    // Convert to IST (UTC+5:30)
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);
    
    const hours = String(istDate.getUTCHours()).padStart(2, '0');
    const minutes = String(istDate.getUTCMinutes()).padStart(2, '0');
    
    return `${hours}:${minutes} IST`;
  } catch {
    return isoString;
  }
}
